import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./components/app";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Authentication } from "./components/authentication";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ErrorBoundary from "./components/errorPageComponent";
import { Routes } from "./common/Routes";
import { NotFound } from "./components/notFound";
import { ForbiddenPage } from "./components/forbiddenPage";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Authentication>
          <ErrorBoundary>
            <Switch>
              <Route
                exact={true}
                path={Routes.NotFound.path}
                component={NotFound}
              />
              <Route
                exact={true}
                path={Routes.Forbidden.path}
                component={ForbiddenPage}
              />
              <Route component={App}/>
            </Switch>
          </ErrorBoundary>
        </Authentication>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);
